import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import styles from './index.module.less'

export default ({ name, userName, num }) => {
  return <div className={styles['multi-img-coll-info']}>
    <div className="coll-title">
      <Icon type="m-xinjianlingganji" className="multi-img-coll-info-icon" />
      <div className="coll-title-text">
        <div className="coll-title-text-name" style={{ maxWidth: '240px' }}>{name}</div>
      </div>
    </div>
    <div className="coll-detail">
      <div className="coll-detail-blogNum">样衣<span style={{ marginLeft: '4px', color: 'var(--m-text-1)' }}>{num}</span></div>
      <div className="coll-detail-line" />
      <div className="coll-detail-userName">{userName}</div>
    </div>
  </div>
}
